import React from 'react';

import {
    Modal, ModalHeader, ModalBody, ModalFooter, Button, FormGroup, Label, Input, Form, Row, Col
} from 'reactstrap';

import PhoneField from './forms/fields/phone';
import Checkbox from './forms/fields/checkbox';

import VerifiedIcon from '../assets/svg/verified_icon.svg';
import GarbageIcon from '../assets/svg/garbage.svg';
import defaultProfilePicture from '../assets/images/user.png';


import Isvg from 'react-inlinesvg';
import { API_ENDPOINT } from '../constants';


// Function to validate email, if email is not valid return error message
function validateEmail(email) {
    if (!email) return 'Email is required';
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return 'Invalid email address';
    return null;
}
function validatePhone(phone) {
    if (!phone) return 'Phone number is required';
    if (phone?.length < 8) return 'Invalid phone number';
    return null;
}

class EventMeetingsModal extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            data: {
                date: '',
                time: '',
                name: { value: '', error: null, label: 'Name'.translate(this.props.lang) },
                role: { value: '', error: null, label: 'Role'.translate(this.props.lang) },
                email: { value: '', error: null, label: 'Email'.translate(this.props.lang) },
                phone: { value: '', error: null, label: 'Phone number'.translate(this.props.lang) },
                identification: 'none',
                allowAlias: true
            },
            identifications: [],
            guests: [],
            colleagues: [],
            searchColleague: '',
            addedColleagues: []
        }
    }
    componentDidMount() {
        let values = [];
        if (this.props.data?.date) {
            values.push({ key: 'date', value: this.props.data.date });
        }
        if (this.props.data?.startTime) {
            values.push({ key: 'time', value: this.props.data.startTime });
        }
        if (this.props.data?.guests) {
            values.push({ key: 'guests', value: this.props.data.guests });
        }
        this.setGuestFormMultipleValue(values);

        const colleaguesModal = this.props.data?.type === 'event' ? true : false;
        if (colleaguesModal) {
            this.getColleagueList(() => this.setInitialColleagues());
        }
        this.checkVideoLinkType();
    }

    setIdentifications = () => {
        let videoLinkType = this.state.videoLinkType;
        let identifications = [];

        if (!videoLinkType) return;

        let setObj = {}

        if (videoLinkType === '0') {
            identifications = [
                { value: 'none', label: 'None'.translate(this.props.lang) },
                { value: 'bankId', label: 'BankID'.translate(this.props.lang) }
            ];
        } else if (videoLinkType === '1') {
            identifications = [
                { value: 'none', label: 'Alias'.translate(this.props.lang) },
            ]
        } else if (videoLinkType === '2') {
            identifications = [
                { value: 'bankId', label: 'BankID'.translate(this.props.lang) }
            ]
            let data = this.state.data;
            data.identification = 'bankId';
            data.allowAlias = false;
            setObj.data = data;
        }
        setObj.identifications = identifications;
        this.setState(setObj);
    }
    checkVideoLinkType = () => {
        if (this.props.selectedGroup) {
            this.setState({ videoLinkType: null }, () => {
                fetch(API_ENDPOINT + `/data/clinic-groups/video-link/${this.props.selectedGroup}`, {
                    method: 'GET',
                    headers: {
                        'content-type': 'application/json'
                    }
                }).then(res => res.json()).then((result) => {
                    this.setState({ videoLinkType: result.videoLink }, () => {
                        this.setIdentifications();
                    });
                })
            })

        }
    }

    setInitialColleagues = () => {
        let addedColleagues = [];
        let colleagues = this.state.colleagues;
        if (this.props.data?.colleagues) {
            this.props.data.colleagues.forEach(colleague => {
                let index = colleagues.findIndex(item => item._id === colleague);
                if (index > -1) {
                    addedColleagues.push(colleagues[index]._id);
                }
            });
        }
        if (addedColleagues.length) {
            this.setState({ addedColleagues });
        }
    }
    getColleagueList = (callback) => {
        const clinicId = this.props.selectedClinic;

        this.setState({ colleagues: [] }, () => {
            fetch(API_ENDPOINT + `/meetings/calendar/colleagues/${clinicId}`, {
                method: 'GET',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                }
            }).then(res => res.json()).then((result) => {
                if (result?.users) {
                    let doctorId = this.props.doctorId ? this.props.doctorId : this.props.uData?._id;
                    let colleagues = result.users?.filter(item => item._id !== doctorId);
                    this.setState({ colleagues }, () => {
                        if (callback) {
                            callback();
                        }
                    });
                }
            })
        })


    }
    setGuestFormValue = (key, value) => {
        let data = this.state.data;
        data[key].value = value;
        data[key].error = null;
        let setObj = { data };
        if (key === 'email' || key === 'phone') {
            setObj.error = null;
        }
        this.setState(setObj);
    }
    setGuestFormMultipleValue = (values) => {
        if (values && values.length) {
            let data = this.state.data;
            let setObj = {}
            let valueKeys = ['date', 'time', 'identification', 'allowAlias'];
            for (let i = 0; i < values.length; i++) {
                let key = values[i].key;
                let value = values[i].value;
                if (key !== 'guests') {

                    if (!valueKeys.includes(key)) {
                        data[key].value = value;
                        data[key].error = null;
                    } else {
                        data[key] = value;
                    }
                } else {
                    setObj.guests = value;
                }


                if (key === 'email' || key === 'phone') {
                    setObj.error = null;
                }
            }
            setObj.data = data;
            this.setState(setObj);
        }
    }
    resetGuestForm = () => {
        let values = [
            { key: 'name', value: '' },
            { key: 'role', value: '' },
            { key: 'email', value: '' },
            { key: 'phone', value: '' },
            { key: 'identification', value: 'none' },
            { key: 'allowAlias', value: true }
        ]
        this.setGuestFormMultipleValue(values)
    }

    checkIfGuestExist = (guest) => {
        let guests = this.state.guests;
        let exist = false;
        guests.forEach(item => {
            if ((item.email && item.email === guest.email) || (item.phone && item.phone === guest.phone)) {
                exist = true;
            }
        });
        return exist;
    }
    addGuest = () => {
        const { name, role, email, phone, identification, allowAlias } = this.state.data;
        let error = false;
        if (!name?.value) {
            error = true;
            let data = this.state.data;
            data.name.error = 'Name is required'.translate(this.props.lang);
            this.setState({ data });
        }
        if (!role?.value) {
            error = true;
            let data = this.state.data;
            data.role.error = 'Role is required'.translate(this.props.lang);
            this.setState({ data });
        }
        if (email?.value && validateEmail(email?.value)) {
            error = true;
            let data = this.state.data;
            data.email.error = !email?.value ? 'Email is required'.translate(this.props.lang) : validateEmail(email?.value)?.translate(this.props.lang);
            this.setState({ data });
        }
        if (phone?.value && validatePhone(phone?.value)) {
            error = true;
            let data = this.state.data;
            data.phone.error = !phone?.value ? 'Phone number is required'.translate(this.props.lang) : validatePhone(phone?.value)?.translate(this.props.lang);
            this.setState({ data });
        }
        // if (!phone?.value) {
        //     error = true;
        //     let data = this.state.data;
        //     data.phone.error = 'Phone number is required'.translate(this.props.lang);
        //     this.setState({ data });
        // }
        if (!email?.value && !phone?.value) {
            error = true;
            this.setState({ error: 'Email or phone number is required'.translate(this.props.lang) });
        } else if (this.checkIfGuestExist({ name: name?.value, email: email?.value, phone: phone?.value })) {
            error = true;
            this.setState({ error: 'Guest with same email or phone number is already added to guest list'.translate(this.props.lang) });
        }
        if (error) return;
        let phoneNumber = phone?.value?.length < 8 ? null : phone?.value?.startsWith('+') ? phone?.value : `+${phone?.value}`;
        let guest = {
            name: name?.value,
            role: role?.value,
            email: email?.value,
            phone: phoneNumber,
            identification: identification,
            allowAlias: allowAlias
        }
        let guests = this.state.guests ?? [];
        guests.push(guest);
        this.setState({ guests, error: null }, () => {
            this.resetGuestForm();
        });
    }


    render() {
        const isOpen = this.props.data;
        const colleaguesModal = this.props.data?.type === 'event' ? true : false;

        const { date, time, name, role, email, phone, identification } = this.state.data;

        const searchColleague = this.state.searchColleague?.toLowerCase() ?? '';
        const colleagues = this.state.colleagues?.filter((colleague, index) => !this.state.addedColleagues.filter(item => item === colleague._id).length && (!searchColleague || (searchColleague && (colleague?.name?.toLowerCase()?.indexOf(searchColleague) !== -1 || colleague?.username?.toLowerCase()?.indexOf(searchColleague) !== -1 || colleague?.userData?.name?.toLowerCase()?.indexOf(searchColleague) !== -1)))) ?? [];
        const guestForm = <>
            <FormGroup className='w-half'>
                <Label>{'Date'.translate(this.props.lang)}</Label>
                <Input type='text' disabled value={date} />
            </FormGroup>
            <FormGroup className='w-half'>
                <Label>{'Time'.translate(this.props.lang)}</Label>
                <Input type='text' disabled value={time} />
            </FormGroup>
            {
                !colleaguesModal ?
                    <>
                        <FormGroup className={name?.error ? 'error-field-wrap w-half' : 'w-half'}>
                            <Label>{'Name'.translate(this.props.lang)}</Label>
                            <Input type='text' value={name?.value} onChange={(e) => {
                                this.setGuestFormValue('name', e.target.value);
                            }} />
                            {name.error ? <div className='error-text'>{name.error}</div> : null}
                        </FormGroup>
                        <FormGroup className={role?.error ? 'error-field-wrap w-half' : 'w-half'}>
                            <Label>{'Role'.translate(this.props.lang)}</Label>
                            <Input type='text' value={role.value} onChange={(e) => {
                                this.setGuestFormValue('role', e.target.value);
                            }} />
                            {role.error ? <div className='error-text'>{role.error}</div> : null}
                        </FormGroup>
                        <FormGroup className={email?.error ? 'error-field-wrap w-full' : 'w-full'}>
                            <Label>{'Email'.translate(this.props.lang)}</Label>
                            <Input type='text' value={email.value} onChange={(e) => {
                                this.setGuestFormValue('email', e.target.value);
                            }} />
                            {email.error ? <div className='error-text'>{email.error}</div> : null}
                        </FormGroup>
                        <FormGroup className={phone?.error ? 'error-field-wrap w-full' : 'w-full'}>
                            <PhoneField
                                countryTwoLetter={this.props.countryTwoLetter}
                                country={this.props.country}
                                label={'Phone number'.translate(this.props.lang)}
                                value={phone.value}
                                onChange={e => {
                                    let value = e?.replace(/ /g, '')?.replace('+', '');
                                    this.setGuestFormValue('phone', value);
                                }}
                            />
                            {phone.error ? <div className='error-text'>{phone.error}</div> : null}
                        </FormGroup>
                        <FormGroup className='w-full'>
                            <Label>
                                {
                                    this.state.identifications?.length > 1 ?
                                        'Select identification method:'.translate(this.props.lang)
                                        :
                                        this.state.identifications?.length === 1 ?
                                            `${'Identification method:'.translate(this.props.lang)} ${this.state.identifications[0].label}`
                                            :
                                            null
                                }
                            </Label>
                            {
                                this.state.identifications?.length > 1 ?
                                    this.state.identifications.map((item, index) => {
                                        return (
                                            <div className='checkbox-item-wrap' key={index}>
                                                <Checkbox
                                                    styleType="radio"
                                                    onChange={(e) => {
                                                        if (item.value === identification) return;
                                                        let data = this.state.data;
                                                        data.identification = item.value;
                                                        if (data.identification === 'none') {
                                                            data.allowAlias = true;
                                                        }
                                                        this.setState({
                                                            data
                                                        })
                                                    }}
                                                    checked={identification === item.value}
                                                    label={item.label}
                                                    style={{ marginBottom: 10 }}
                                                />
                                            </div>
                                        )
                                    })
                                    :
                                    null
                            }
                            {
                                this.state.identifications?.length > 1 ?
                                    <div className='checkbox-item-wrap'>
                                        <Checkbox
                                            onChange={(e) => {
                                                if (identification === 'none') return;
                                                let data = this.state.data;
                                                data.allowAlias = e.target.checked;
                                                this.setState({
                                                    data
                                                })
                                            }}
                                            disabled={identification === 'none'}
                                            checked={this.state.data?.allowAlias}
                                            label={'Allow alias'.translate(this.props.lang)}
                                        />
                                    </div>
                                    :
                                    null
                            }


                        </FormGroup>

                        <div className='add-guest-btn-wrap'>
                            <Button color="primary" onClick={() => {
                                this.addGuest();
                            }}>
                                {'Add guest'.translate(this.props.lang)}
                            </Button>
                            {this.state.error ? <div style={{ marginTop: 10 }} className='error-text'>{this.state.error}</div> : null}
                        </div>
                    </>
                    :
                    <>
                        <div className='colleagues-section-wrap'>
                            <div className='colleagues-section-title'>{'Colleagues'.translate(this.props.lang)}</div>
                            <div className='search-colleague-input-wrap'>
                                <Input
                                    type='text'
                                    placeholder={`${'Search'.translate(this.props.lang)}...`}
                                    value={this.state.searchColleague}
                                    onChange={(e) => {
                                        this.setState({ searchColleague: e.target.value });
                                    }}
                                />
                            </div>
                            <div className='colleague-items-wrap'>
                                {
                                    colleagues.map((colleague, index) => {
                                        return (
                                            <div className='colleague-item-wrap' key={index}>
                                                <div className='colleague-data-wrap'>
                                                    <div className='colleague-profile-pic-wrap'>
                                                        <img alt='profile pic' src={colleague?.profilePicture ? API_ENDPOINT + colleague.profilePicture : defaultProfilePicture} />
                                                    </div>
                                                    <div className='colleague-name-wrap'>
                                                        <div className='colleague-name'>{colleague.name}</div>
                                                        <div className='colleague-username'>{colleague.username}</div>
                                                    </div>

                                                </div>
                                                <div className='add-colleague-btn-wrap'>
                                                    <Button color="primary" onClick={() => {
                                                        let addedColleagues = this.state.addedColleagues;
                                                        addedColleagues.push(colleague?._id);
                                                        this.setState({ addedColleagues });
                                                    }}>
                                                        {'Add'.translate(this.props.lang)}
                                                    </Button>
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                            </div>


                        </div>
                    </>
            }

        </>;
        const guestItem = (guest, index) => {
            let contact = '';
            if (guest.email && guest.phone) {
                contact = `${guest.phone} - ${guest.email}`;
            } else if (guest.email) {
                contact = guest.email;
            } else if (guest.phone) {
                contact = `${guest.phone}`;
            }
            let identification = this.state.identifications.find(item => item.value === guest.identification)?.label;
            if (guest.identification === 'none') identification = 'No eID chosen'.translate(this.props.lang);
            if (guest.allowAlias && guest.identification === 'bankId') {
                identification += ` (${'allowed alias'.translate(this.props.lang)})`;
            }
            return (
                <div key={index} className='guest-item-wrap'>
                    <div>
                        <div className='guest-name'>{guest.name} - <span>{guest.role}</span></div>
                        {contact ? <div className='guest-contact'>{contact}</div> : null}
                        {
                            guest.identification ?
                                <div className='guest-identification-wrap'>
                                    <Isvg src={VerifiedIcon} /> {identification}
                                </div>
                                :
                                null
                        }
                    </div>
                    {
                        !guest.guestId || true ?
                            <div className='remove-guest-btn-wrap' onClick={() => {
                                let guests = this.state.guests;
                                guests.splice(index, 1);
                                this.setState({ guests });
                            }}>
                                <Isvg src={GarbageIcon} />
                            </div>
                            :
                            null
                    }

                </div>
            )
        }
        const colleagueItem = (colleague, index) => {
            return (
                <div key={index} className='colleague-item-wrap'>
                    <div className='colleague-data-wrap'>
                        <div className='colleague-profile-pic-wrap'>
                            <img alt='profile pic' src={colleague?.profilePicture ? API_ENDPOINT + colleague.profilePicture : defaultProfilePicture} />
                        </div>
                        <div className='colleague-name-wrap'>
                            <div className='colleague-name'>{colleague.name}</div>
                            <div className='colleague-username'>{colleague.username}</div>
                        </div>

                    </div>
                    <div className='remove-guest-btn-wrap' onClick={() => {
                        let addedColleagues = this.state.addedColleagues;
                        let index = addedColleagues.findIndex(item => item === colleague._id);
                        if (index > -1) {
                            addedColleagues.splice(index, 1);
                            this.setState({ addedColleagues });
                        }
                    }}>
                        <Isvg src={GarbageIcon} />
                    </div>
                </div>
            )
        }
        const guestsList = <>
            <h5>{colleaguesModal ? 'Added colleagues'.translate(this.props.lang) : 'Added guests'.translate(this.props.lang)}</h5>
            {
                colleaguesModal ?
                    this.state.addedColleagues.map((colleague, index) => {
                        let colleagueData = this.state.colleagues.find(item => item._id === colleague);
                        return colleagueItem(colleagueData, index)
                    })
                    :
                    this.state.guests.map((guest, index) => {
                        return guestItem(guest, index)
                    })
            }
        </>;


        return (
            <Modal
                isOpen={isOpen}
                centered
                size={this.props.size ? this.props.size : 'lg'}
                zIndex={this.props.zIndex ? this.props.zIndex : 1050}
                className="event-meetings-modal-wrap"
            >
                <ModalHeader
                    toggle={() => {
                        this.props?.onClose?.()
                    }}
                    close={<button type="button" className="close" style={{ position: 'absolute', top: '15px', right: '15px' }} onClick={() => this.props?.onClose?.()}>&times;</button>}
                    className="event-meetings-modal-header-wrap"
                >
                    {colleaguesModal ? 'Add colleagues to video call'.translate(this.props.lang) : 'Add guests to video call'.translate(this.props.lang)}
                    {!colleaguesModal ? <span>{'Invited guests cannot see the patient chat'.translate(this.props.lang)}</span> : null}

                </ModalHeader>

                <ModalBody className="event-meetings-modal-body-wrap">
                    <div className='event-meetings-modal-body-left-wrap'>
                        {guestForm}
                    </div>
                    <div className='event-meetings-modal-body-right-wrap'>
                        {guestsList}

                    </div>

                </ModalBody>
                <ModalFooter className="buttons-right-blue event-meetings-modal-footer-wrap ">
                    <Button style={{ minWidth: 100 }} color="primary" onClick={() => this.props?.onClose?.()} >
                        {this.props.closeButtonText ? this.props.closeButtonText : 'Close'.translate(this.props.lang)}
                    </Button>
                    {
                        this.props.saveData ?
                            <Button
                                style={{ minWidth: 100 }}
                                color="primary"
                                onClick={() => {
                                    let data = colleaguesModal ? this.state.addedColleagues : this.state.guests;
                                    this.props.saveData(data);
                                }} >
                                {'Save'.translate(this.props.lang)}
                            </Button>
                            :
                            null
                    }

                </ModalFooter>
            </Modal>

        )
    }
}

export default EventMeetingsModal;